import { Flex, Switch, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type ShowMarkersToggleProps = {
  checked: boolean;
  onChange: (value: boolean) => void;
};

export default function ShowMarkersToggle({ checked, onChange }: ShowMarkersToggleProps) {
  return (
    <Flex
      bg="white"
      h={28}
      pl="xs"
      pr="xxs"
      style={{ borderRadius: 'var(--mantine-radius-xl)' }}
      align="center"
      gap="xxxs"
    >
      <Text size="sm" fw={FONT_WEIGHTS.medium} c="black" style={{ whiteSpace: 'nowrap' }}>
        Show markers
      </Text>
      <Switch
        size="xs"
        checked={checked}
        onChange={e => onChange(e.currentTarget.checked)}
        color="brand.6"
      />
    </Flex>
  );
}
